export default __webpack_public_path__ + "static/media/plus-white.d7b5885f.svg";